export const DISPLAY_SETTINGS_UPDATE_HOME_START_VIDEO = Symbol('DISPLAY_SETTINGS_UPDATE_HOME_START_VIDEO');
export const MARK_HOME_START_VIDEO = Symbol('MARK_HOME_START_VIDEO');
export const UNMARK_HOME_START_VIDEO = Symbol('UNMARK_HOME_START_VIDEO');

/**
 * @param {number} startVideoId
 * @return {{type: symbol, payload: {startVideoId}}}
 */
export const updateHomeStartVideoAction = (startVideoId) => {
  return {
    type: DISPLAY_SETTINGS_UPDATE_HOME_START_VIDEO,
    payload: {
      startVideoId,
    },
  };
};

/**
 * @returns {{payload: {video}, type: symbol}}
 */
export const markHomeStartVideoAction = (video) => ({
  type: MARK_HOME_START_VIDEO,
  payload: {
    video,
  },
});

/**
 * @returns {{payload: {video}, type: symbol}}
 */
export const unmarkHomeStartVideoAction = (video) => ({
  type: UNMARK_HOME_START_VIDEO,
  payload: {
    video,
  },
});
